import { useCallback, useState,useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Option } from '../../interface/Option';
import { network, Results } from '../../interface/Network';
import { NetworkAxiosInstance } from '../../Network/NetworkAxiosInstance';


const NetworkNames = ({ onChange , clear, defaultValue }: any) => {
  const [cacheOptions, setCacheOptions] = useState<{ [key: string]: Option[] }>(
    {}
  );
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [inputKey, setInputKey] = useState(0); // To reset AsyncSelect when needed

const loadOptions = useCallback(
  async (inputValue: string): Promise<Option[]> => {
    if (cacheOptions[inputValue]) {
      return cacheOptions[inputValue];
    }
    try {
      const response = await NetworkAxiosInstance.get<network>(`getnetwork/${inputValue}`, {
        params: { active: "true" }, 
      });

      const data: Results[] = response.data.result;

      const options: Option[] = data
        .map((item: Results) => ({
          value: item.id,
          label: item.network_name,
        }))
        .filter((option: Option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );

      setCacheOptions((prevCache) => ({
        ...prevCache,
        [inputValue]: options,
      }));
      return options;
    } catch (error) {
      console.error("Error loading options:", error);
      return [];
    }
  },
  [cacheOptions]
);
  const handleChange = (newValue: any) => {
    setSelectedOptions(newValue || []);
    onChange(newValue || []);
  };
  // clear
  useEffect(() => {
    if (clear) {
      setSelectedOptions([]); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1); // Reset AsyncSelect
    }
  }, [clear]);

// Set the default value when modifying
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1); 
    }
  }, [defaultValue]);
  return (
    <AsyncSelect
      cacheOptions
      className="controlWidth mb-3"
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      loadOptions={loadOptions}
      onChange={handleChange}
      defaultOptions
      value={selectedOptions} // Set the chosen value

      placeholder="Type at least 3 characters to search..."
    />
  );
};

export default NetworkNames;